<div class="media profile-media">
  <img class="img-50 rounded" [src]="img" alt="">
  <div class="media-body"><span>{{'Welcome' | translate}}</span>
    <p class="mb-0 font-roboto">{{name}}<i class="middle fa fa-angle-down"></i></p>
  </div>
</div>
<ul class="profile-dropdown onhover-show-div">
  <li><a (click)="goToProfile()"><app-feather-icons [icon]="'user'"></app-feather-icons><span>{{ 'Profile' | translate}} </span></a></li>
  <!-- <li><a href="#"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li>
  <li><a href="#"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li> -->
  <!-- <li><a href="#"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Ajustes</span></a></li> -->
  <li (click)="service?.signOut()"><a ><app-feather-icons [icon]="'log-out'"></app-feather-icons><span>{{'Exit' | translate}}</span></a></li>
</ul>